import { ReactNode, useEffect } from "react";
import './MainLayout.css'

export function MainLayout({ children }: { children: ReactNode }) {
    useEffect(() => {
        document.body.style.background = "#e9eefb";
    }, [])

    return (
        <div className="main-content">
            <div className="max-w-[1000px] mx-auto p-4 space-y-6">
                {children}
            </div>
        </div>
    )
}